import { EventBus } from "../../../eventbus";

export default {
  props: {
    title: String,
    files: [FileList, Array],
    buttons: Array,
  },
  data() {
    return {
      updatedFileList: [],
    };
  },
  created() {
    this.setInitUpdatedFiles();
  },
  methods: {
    setInitUpdatedFiles() {
      //change the updated file list to the selected files and remove the length key
      this.updatedFileList = Array.from(this.files).filter((file) => file.name);
    },
    removeFile(e, file) {
      e.preventDefault();

      this.updatedFileList = this.updatedFileList.filter(
        (fileItem) => fileItem !== file
      );

      //check if empty
      this.checkEmpty();
    },
    checkEmpty() {
      if (this.updatedFileList.length === 0) {
        //is empty so go back to upload
        EventBus.$emit(`mobile-upload-updateStep`, {
          id: "upload",
        });

        this.$router.push(`/${this.$store.state.company}/upload`);
      }
    },
  },
  computed: {
    buttonsWithUpdatedFiles() {
      return this.buttons.map((button) => {
        if (!button.emitterData.data) {
          button.emitterData.data = {};
        }

        button.emitterData.data.files = this.updatedFileList;

        return button;
      });
    },
  },
  watch: {
    files() {
      this.setInitUpdatedFiles();
    },
  },
};
